
import { Component, Vue, Prop } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import {
	activityCouponactivityCouponPageInit,
} from "@/api/finance";

import {
	getSearchDate,
	nextDay
} from "@/utils/index"

@Component({
	name: '',
	components: {
		PageFooter,
		PickerDate
	}
})

export default class ProductList extends Vue {
	@Prop({ default: {} }) msg!: any
	private keywords = ''
	private tablelist: any = []
	private tableloading = false
	private pageSize = 20
	private pageNo = 1
	private total = 0
	private choosemsg: any = this.msg
	private filterTime: any = getSearchDate(1).join('/')

	private mounted() {
		console.log(this.choosemsg, 111)
		this.gettablelist()
	}

	private returnchoosemsg() {
		return this.choosemsg
	}
	private checkchange(e, row) {
		this.tablelist = this.tablelist.map(v => {
			v.IsChoose = false
			if (v.Id == row.Id) {
				v.IsChoose = true
				this.choosemsg = v
			}
			return v
		})
	}
	private async gettablelist() {
		try {
			this.tableloading = true;

			let params: any = {
				Keywords: this.keywords,
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize
			}

			if (this.filterTime){
				var splitList = this.filterTime.split('/');
				params.StartAddTime = splitList[0]
				params.EndAddTime =  nextDay(splitList[1],1)
			}

			let res = await activityCouponactivityCouponPageInit(params)
			if (res.IsSuccess) {
				this.tablelist = res.Result.Results.map(v => {
					if (v.Id == this.choosemsg.Id) {
						v.IsChoose = true
						this.choosemsg = v
					} else {
						v.IsChoose = false
					}
					return v
				})
				this.total = res.Result.Total
			}
		} finally {
			this.tableloading = false
		}
	}
	private changePage(e) {
		this.pageNo = e
		this.gettablelist()
	}
	private doSearch() {
		this.pageNo = 1
		this.gettablelist()
	}
}
